
(function() {
    'use strict';

    var ScreeningBusinessSearchCtrl = function ($scope, $http) {
        $scope.formModel = {
            screeningBusinessName : ""
        };
        $scope.businessRecords =[];
        $scope.getBusinessNames = function(managerId) {
            $scope.businessRecords = {};
            $http.get( WEBAPP_PATH + '/screeningBusinessRecord/businessRecordsForManager/'+managerId+"?term="+encodeURIComponent($scope.formModel.screeningBusinessName)).then(
                function(response){
                    var objectArr = [];
                    angular.forEach(response.data, function(resp){
                        console.log(resp.name);
                        objectArr.push({
                            id:         resp.id,
                            linked:     resp.linked,
                            name:       resp.name,
                            businessId: resp.businessId,
                            postcode:   resp.postcode
                        });
                    });
                    $scope.businessRecords = objectArr;
                }
            );
        }
    }

    ScreeningBusinessSearchCtrl.$inject = ['$scope', '$http'];
    angular.module('app').controller('ScreeningBusinessSearchCtrl',ScreeningBusinessSearchCtrl);
}());